import {
  Spinner,
  Button,
  GreyGrey50,
  GreyGrey70,
  IconMagnifyingGlass,
  Center,
  Flex
} from '@sequencehq/core-components'
import { useNavigationV3Context } from 'components/NavigationV3/hooks/useNavigationV3Context'
import { MainMenu } from 'components/NavigationV3/components/Header/MainMenu'
import { AddMenu } from 'components/NavigationV3/components/Header/AddMenu'
import { useGlobalSearchState } from 'modules/GlobalSearch/useGlobalSearchShortcut'

export const Header = () => {
  const { data } = useNavigationV3Context()
  // `isEffectivelyCollapsed`, not the persisted preference: a phone drawer
  // always shows the expanded nav, so its header must match.
  const { isEffectivelyCollapsed: isNavigationCollapsed } = data
  const { setIsOpen: setSearchOpen } = useGlobalSearchState()

  return (
    <Flex
      px="8px"
      py="8px"
      justifyContent={'flex-start'}
      alignItems="center"
      width="100%"
      gap="0px"
    >
      {data.isSwitchingWorkspace ? (
        <Center height="32px">
          <Spinner boxSize="16px" color={GreyGrey50} />
        </Center>
      ) : (
        <MainMenu isCollapsed={isNavigationCollapsed} />
      )}

      {!isNavigationCollapsed && <Flex flex="1" />}
      {!isNavigationCollapsed && (
        <Flex gap="4px" alignItems="center" flexShrink="0">
          <Button
            variant="ghost"
            size="28px"
            icon={<IconMagnifyingGlass color={GreyGrey70} />}
            aria-label="Search"
            onClick={() => setSearchOpen(true)}
            data-testid="global-search.trigger"
          />
          <AddMenu />
        </Flex>
      )}
    </Flex>
  )
}
